export function isPointInBounds(
  geo: { lat: number; lng: number },
  bounds: google.maps.LatLngBoundsLiteral,
) {
  // 위도가 남쪽과 북쪽 경계 사이에 있는지 확인
  const latInBounds = geo.lat >= bounds.south && geo.lat <= bounds.north;

  // 경도가 서쪽과 동쪽 경계 사이에 있는지 확인
  // 날짜 변경선을 가로지르는 경우를 처리
  let lngInBounds: boolean;
  if (bounds.west <= bounds.east) {
    lngInBounds = geo.lng >= bounds.west && geo.lng <= bounds.east;
  } else {
    // 날짜 변경선을 가로지르는 경우
    lngInBounds = geo.lng >= bounds.west || geo.lng <= bounds.east;
  }

  return latInBounds && lngInBounds;
}
